import React from "react";
import styled from "styled-components";

// Utils
import colors from "../../styles/utils/colors";

/**
 * Style
 */
const StyledFooter = styled.footer`
  background: ${colors.light.white};
  border-top: 1px solid ${colors.light.light300};

  &.Footer {
    > div {
      display: flex;
      justify-content: space-between;

      padding-top: 60px;
      padding-bottom: 60px;
      font-size: 1em;
      color: ${colors.light.primary700};

      a {
        color: ${colors.light.light500};

        &:hover {
          text-decoration: underline;
        }
      }

      dl {
        dt {
          font-weight: bold;
          margin-bottom: 25px;
          font-size: 21px;
        }

        dd {
          margin-bottom: 5px;
        }
      }

      .Footer__Company {
        width: 50%;

        padding-right: 20px;

        > a {
          margin-bottom: 20px;
          display: inline-block;
        }
      }

      .Footer__GetInTouch {
        width: 30%;

        svg {
          fill: ${colors.light.light700};
          width: 20px;

          &:hover {
            fill: ${colors.light.light500};
          }
        }

        dd:nth-child(3) {
          display: flex;
          align-items: center;
        }

        a {
          margin: 4px 5px 0 5px;

          &:hover {
            text-decoration: none;
          }
        }

        dd {
          &:last-child {
            margin-top: 10px;
            padding-top: 10px;
            border-top: 1px dashed ${colors.light.light400};
          }
        }
      }

      .Footer__HelpfulLinks {
        width: 15%;
      }
    }
  }

  /**
  * Responsive
  */
  @media (max-width: 991px) {
    &.Footer {
      div {
        flex-wrap: wrap;

        p {
          width: 80%;
        }

        .Footer__Company {
          flex: 100%;
          margin-bottom: 25px;
        }

        .Footer__GetInTouch,
        .Footer__HelpfulLinks {
          flex: 33.33333%;
        }

        .Footer__GetInTouch {
          dd {
            &:last-child {
              margin-top: 0;
              padding-top: 0;
              border-top: none;
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    &.Footer {
      div {
        p {
          width: 100%;
        }

        .Footer__GetInTouch,
        .Footer__HelpfulLinks {
          flex: 50%;
        }

        .Footer__GetInTouch {
          margin-top: 25px;
        }
      }
    }
  }
`;

const Footer = () => {
  return (
    <StyledFooter className="Footer">
      <div className="Container">
        {/* Company */}
        <div className="Footer__Company">
          <a href="{{ home_url('/') }}">
            <svg width="150px" viewBox="0 0 204 23" version="1.1">
              <title>ZIROTO.HERO</title>
              <g
                id="Page-1"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
              >
                <path
                  d="M17.6840556,22 L17.6840556,17.3632332 L8.38001689,17.3632332 L17.6535506,1.43959967 L17.6535506,0.493943275 L1.27234141,0.493943275 L1.27234141,5.43576057 L9.32567329,5.43576057 L0.23516988,21.0238386 L0.23516988,22 L17.6840556,22 Z M26.1339531,22 L26.1339531,0.493943275 L20.8260753,0.493943275 L20.8260753,22 L26.1339531,22 Z M35.590517,22 L35.590517,16.1430314 L36.8107188,16.1430314 C37.0954326,16.1430314 37.3750622,16.1379472 37.6496076,16.1277788 C37.924153,16.1176105 38.2037826,16.102358 38.4884963,16.0820213 L42.2406168,22 L48.0670804,22 L43.4303136,14.6787892 C44.5284952,14.0483516 45.367384,13.2247154 45.9469798,12.2078806 C46.5265757,11.1910457 46.8163736,9.96067557 46.8163736,8.51677011 C46.8163736,7.07286465 46.5672491,5.8424945 46.069,4.82565966 C45.5707509,3.80882483 44.8335457,2.98010444 43.8573842,2.3394985 C42.8812228,1.69889255 41.6661052,1.23114853 40.2120314,0.936266428 C38.7579575,0.641384326 37.0750959,0.493943275 35.1634464,0.493943275 L30.3741543,0.493943275 L30.3741543,22 L35.590517,22 Z M36.6886987,11.6587897 L35.590517,11.6587897 L35.590517,5.37475047 L36.6886987,5.37475047 C38.5190014,5.37475047 39.7900449,5.64421171 40.5018293,6.18313417 C41.2136137,6.72205663 41.5695059,7.49993528 41.5695059,8.51677011 C41.5695059,9.53360494 41.2136137,10.3114836 40.5018293,10.8504061 C39.7900449,11.3893285 38.5190014,11.6587897 36.6886987,11.6587897 Z M59.9030379,22.4270706 C61.3266067,22.4270706 62.6637445,22.1626936 63.9144513,21.6339395 C65.1651582,21.1051853 66.2582556,20.3578117 67.1937437,19.3918187 C68.1292317,18.4258256 68.866437,17.2564655 69.4053594,15.8837385 C69.9442819,14.5110115 70.2137431,12.9705067 70.2137431,11.2622242 C70.2137431,9.55394164 69.9442819,8.01343687 69.4053594,6.64070984 C68.866437,5.26798282 68.1292317,4.09862276 67.1937437,3.13262967 C66.2582556,2.16663658 65.1651582,1.41926297 63.9144513,0.89050886 C62.6637445,0.361754747 61.3266067,0.09737769 59.9030379,0.09737769 C58.4794691,0.09737769 57.1423313,0.361754747 55.8916245,0.89050886 C54.6409176,1.41926297 53.5478202,2.16663658 52.6123321,3.13262967 C51.6768441,4.09862276 50.9396388,5.26798282 50.4007164,6.64070984 C49.8617939,8.01343687 49.5923327,9.55394164 49.5923327,11.2622242 C49.5923327,12.9705067 49.8617939,14.5110115 50.4007164,15.8837385 C50.9396388,17.2564655 51.6768441,18.4258256 52.6123321,19.3918187 C53.5478202,20.3578117 54.6409176,21.1051853 55.8916245,21.6339395 C57.1423313,22.1626936 58.4794691,22.4270706 59.9030379,22.4270706 Z M59.9030379,17.7292937 C59.1912535,17.7292937 58.535395,17.5869368 57.9354625,17.3022231 C57.3355299,17.0175093 56.81186,16.6056912 56.3644527,16.0667687 C55.9170454,15.5278463 55.5713215,14.8669036 55.3272811,14.0839408 C55.0832408,13.300978 54.9612206,12.4112475 54.9612206,11.4147494 C54.9612206,10.4182512 55.0832408,9.52852077 55.3272811,8.74555795 C55.5713215,7.96259513 55.9170454,7.30165248 56.3644527,6.76273002 C56.81186,6.22380756 57.3355299,5.81198945 57.9354625,5.5272757 C58.535395,5.24256195 59.1912535,5.10020507 59.9030379,5.10020507 C60.6148223,5.10020507 61.2706808,5.24256195 61.8706133,5.5272757 C62.4705459,5.81198945 62.9942158,6.22380756 63.4416231,6.76273002 C63.8890304,7.30165248 64.2347543,7.96259513 64.4787946,8.74555795 C64.722835,9.52852077 64.8448552,10.4182512 64.8448552,11.4147494 C64.8448552,12.4112475 64.722835,13.300978 64.4787946,14.0839408 C64.2347543,14.8669036 63.8890304,15.5278463 63.4416231,16.0667687 C62.9942158,16.6056912 62.4705459,17.0175093 61.8706133,17.3022231 C61.2706808,17.5869368 60.6148223,17.7292937 59.9030379,17.7292937 Z M82.8123267,22 L82.8123267,5.43576057 L89.1573761,5.43576057 L89.1573761,0.493943275 L71.1593995,0.493943275 L71.1593995,5.43576057 L77.5044489,5.43576057 L77.5044489,22 L82.8123267,22 Z M100.413738,22.4270706 C101.837306,22.4270706 103.174444,22.1626936 104.425151,21.6339395 C105.675858,21.1051853 106.768955,20.3578117 107.704443,19.3918187 C108.639931,18.4258256 109.377137,17.2564655 109.916059,15.8837385 C110.454982,14.5110115 110.724443,12.9705067 110.724443,11.2622242 C110.724443,9.55394164 110.454982,8.01343687 109.916059,6.64070984 C109.377137,5.26798282 108.639931,4.09862276 107.704443,3.13262967 C106.768955,2.16663658 105.675858,1.41926297 104.425151,0.89050886 C103.174444,0.361754747 101.837306,0.09737769 100.413738,0.09737769 C98.9901689,0.09737769 97.6530311,0.361754747 96.4023242,0.89050886 C95.1516174,1.41926297 94.05852,2.16663658 93.1230319,3.13262967 C92.1875439,4.09862276 91.4503386,5.26798282 90.9114161,6.64070984 C90.3724937,8.01343687 90.1030325,9.55394164 90.1030325,11.2622242 C90.1030325,12.9705067 90.3724937,14.5110115 90.9114161,15.8837385 C91.4503386,17.2564655 92.1875439,18.4258256 93.1230319,19.3918187 C94.05852,20.3578117 95.1516174,21.1051853 96.4023242,21.6339395 C97.6530311,22.1626936 98.9901689,22.4270706 100.413738,22.4270706 Z M100.413738,17.7292937 C99.7019533,17.7292937 99.0460948,17.5869368 98.4461623,17.3022231 C97.8462297,17.0175093 97.3225598,16.6056912 96.8751524,16.0667687 C96.4277451,15.5278463 96.0820213,14.8669036 95.8379809,14.0839408 C95.5939406,13.300978 95.4719204,12.4112475 95.4719204,11.4147494 C95.4719204,10.4182512 95.5939406,9.52852077 95.8379809,8.74555795 C96.0820213,7.96259513 96.4277451,7.30165248 96.8751524,6.76273002 C97.3225598,6.22380756 97.8462297,5.81198945 98.4461623,5.5272757 C99.0460948,5.24256195 99.7019533,5.10020507 100.413738,5.10020507 C101.125522,5.10020507 101.781381,5.24256195 102.381313,5.5272757 C102.981246,5.81198945 103.504916,6.22380756 103.952323,6.76273002 C104.39973,7.30165248 104.745454,7.96259513 104.989494,8.74555795 C105.233535,9.52852077 105.355555,10.4182512 105.355555,11.4147494 C105.355555,12.4112475 105.233535,13.300978 104.989494,14.0839408 C104.745454,14.8669036 104.39973,15.5278463 103.952323,16.0667687 C103.504916,16.6056912 102.981246,17.0175093 102.381313,17.3022231 C101.781381,17.5869368 101.125522,17.7292937 100.413738,17.7292937 Z M115.757775,22.1830303 C116.693263,22.1830303 117.476226,21.8728956 118.106664,21.2526264 C118.737101,20.6323571 119.05232,19.8138051 119.05232,18.7969703 C119.05232,18.3495629 118.965889,17.9275765 118.793027,17.5310109 C118.620165,17.1344453 118.386293,16.7887215 118.091411,16.4938394 C117.796529,16.1989573 117.450805,15.9701694 117.05424,15.8074759 C116.657674,15.6447823 116.225519,15.5634355 115.757775,15.5634355 C115.310368,15.5634355 114.893466,15.6447823 114.507068,15.8074759 C114.120671,15.9701694 113.780032,16.1989573 113.485149,16.4938394 C113.190267,16.7887215 112.96148,17.1344453 112.798786,17.5310109 C112.636092,17.9275765 112.554746,18.3495629 112.554746,18.7969703 C112.554746,19.8138051 112.86488,20.6323571 113.485149,21.2526264 C114.105419,21.8728956 114.862961,22.1830303 115.757775,22.1830303 Z M128.173329,22 L128.173329,13.4890924 L135.98262,13.4890924 L135.98262,22 L141.290498,22 L141.290498,0.493943275 L135.98262,0.493943275 L135.98262,8.5777802 L128.173329,8.5777802 L128.173329,0.493943275 L122.865451,0.493943275 L122.865451,22 L128.173329,22 Z M159.776555,22 L159.776555,17.3632332 L150.594537,17.3632332 L150.594537,13.5806076 L157.885242,13.5806076 L157.885242,8.88283065 L150.594537,8.88283065 L150.594537,5.43576057 L159.776555,5.43576057 L159.776555,0.493943275 L145.378174,0.493943275 L145.378174,22 L159.776555,22 Z M168.623018,22 L168.623018,16.1430314 L169.84322,16.1430314 C170.127934,16.1430314 170.407563,16.1379472 170.682109,16.1277788 C170.956654,16.1176105 171.236284,16.102358 171.520998,16.0820213 L175.273118,22 L181.099582,22 L176.462815,14.6787892 C177.560996,14.0483516 178.399885,13.2247154 178.979481,12.2078806 C179.559077,11.1910457 179.848875,9.96067557 179.848875,8.51677011 C179.848875,7.07286465 179.59975,5.8424945 179.101501,4.82565966 C178.603252,3.80882483 177.866047,2.98010444 176.889885,2.3394985 C175.913724,1.69889255 174.698606,1.23114853 173.244533,0.936266428 C171.790459,0.641384326 170.107597,0.493943275 168.195948,0.493943275 L163.406656,0.493943275 L163.406656,22 L168.623018,22 Z M169.7212,11.6587897 L168.623018,11.6587897 L168.623018,5.37475047 L169.7212,5.37475047 C171.551503,5.37475047 172.822546,5.64421171 173.534331,6.18313417 C174.246115,6.72205663 174.602007,7.49993528 174.602007,8.51677011 C174.602007,9.53360494 174.246115,10.3114836 173.534331,10.8504061 C172.822546,11.3893285 171.551503,11.6587897 169.7212,11.6587897 Z M192.935539,22.4270706 C194.359108,22.4270706 195.696246,22.1626936 196.946953,21.6339395 C198.197659,21.1051853 199.290757,20.3578117 200.226245,19.3918187 C201.161733,18.4258256 201.898938,17.2564655 202.437861,15.8837385 C202.976783,14.5110115 203.246244,12.9705067 203.246244,11.2622242 C203.246244,9.55394164 202.976783,8.01343687 202.437861,6.64070984 C201.898938,5.26798282 201.161733,4.09862276 200.226245,3.13262967 C199.290757,2.16663658 198.197659,1.41926297 196.946953,0.89050886 C195.696246,0.361754747 194.359108,0.09737769 192.935539,0.09737769 C191.51197,0.09737769 190.174833,0.361754747 188.924126,0.89050886 C187.673419,1.41926297 186.580321,2.16663658 185.644833,3.13262967 C184.709345,4.09862276 183.97214,5.26798282 183.433218,6.64070984 C182.894295,8.01343687 182.624834,9.55394164 182.624834,11.2622242 C182.624834,12.9705067 182.894295,14.5110115 183.433218,15.8837385 C183.97214,17.2564655 184.709345,18.4258256 185.644833,19.3918187 C186.580321,20.3578117 187.673419,21.1051853 188.924126,21.6339395 C190.174833,22.1626936 191.51197,22.4270706 192.935539,22.4270706 Z M192.935539,17.7292937 C192.223755,17.7292937 191.567896,17.5869368 190.967964,17.3022231 C190.368031,17.0175093 189.844361,16.6056912 189.396954,16.0667687 C188.949547,15.5278463 188.603823,14.8669036 188.359782,14.0839408 C188.115742,13.300978 187.993722,12.4112475 187.993722,11.4147494 C187.993722,10.4182512 188.115742,9.52852077 188.359782,8.74555795 C188.603823,7.96259513 188.949547,7.30165248 189.396954,6.76273002 C189.844361,6.22380756 190.368031,5.81198945 190.967964,5.5272757 C191.567896,5.24256195 192.223755,5.10020507 192.935539,5.10020507 C193.647324,5.10020507 194.303182,5.24256195 194.903115,5.5272757 C195.503047,5.81198945 196.026717,6.22380756 196.474124,6.76273002 C196.921532,7.30165248 197.267256,7.96259513 197.511296,8.74555795 C197.755336,9.52852077 197.877356,10.4182512 197.877356,11.4147494 C197.877356,12.4112475 197.755336,13.300978 197.511296,14.0839408 C197.267256,14.8669036 196.921532,15.5278463 196.474124,16.0667687 C196.026717,16.6056912 195.503047,17.0175093 194.903115,17.3022231 C194.303182,17.5869368 193.647324,17.7292937 192.935539,17.7292937 Z"
                  id="brand"
                  fill={`${colors.dark.dark600}`}
                  fillRule="nonzero"
                ></path>
              </g>
            </svg>{" "}
            &#169; 2020
          </a>
          <p>
            <b>Ziro To Hero</b> is a vision, not just an e-learning
            website; we tend to scale the quality of educational
            content in Darija by working intensely into presenting our
            courses in a more systematic and easy process to grasp.
            The goal is to give complete guidance for any person who
            wants to master a career.
          </p>
        </div>

        {/* Get In Touch */}
        <div className="Footer__GetInTouch">
          <dl>
            <dt>Get In Touch</dt>
            <dd>
              <b>Mail:</b>{" "}
              <a href="mailto: zirotohero1@gmail.com">
                zirotohero1@gmail.com
              </a>
            </dd>
            <dd>
              <b>Social Media: </b>

              <a href="https://www.twitter.com/ziro_to_hero">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className="bui-Icon bui-Icon--large"
                >
                  <title>Twitter</title>
                  <path d="M7.547 21.5c9.056 0 14.0092-7.5028 14.0092-14.0092 0-.2131 0-.4253-.0144-.6365a10.0178 10.0178 0 0 0 2.4565-2.5486 9.8278 9.8278 0 0 1-2.828.7747A4.9408 4.9408 0 0 0 23.335 2.357a9.8671 9.8671 0 0 1-3.1265 1.195c-1.5263-1.6228-3.9514-2.02-5.9156-.9688-1.9641 1.0512-2.9789 3.2893-2.4752 5.4594A13.9785 13.9785 0 0 1 1.6703 2.8985C.3635 5.1482 1.031 8.0263 3.1946 9.471A4.887 4.887 0 0 1 .96 8.8548v.0624c.0007 2.3438 1.6528 4.3625 3.9501 4.8266a4.9158 4.9158 0 0 1-2.2232.0844c.645 2.0057 2.4935 3.3797 4.6 3.4193a9.8796 9.8796 0 0 1-6.1147 2.1119A10.0226 10.0226 0 0 1 0 19.2884a13.9392 13.9392 0 0 0 7.547 2.2078"></path>
                </svg>
              </a>

              <a
                href="https://www.facebook.com/zirotoheroo"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className="bui-Icon bui-Icon--large"
                >
                  <title>Facebook</title>
                  <path
                    fillRule="evenodd"
                    d="M22.6753 0H1.3245C.5929 0 0 .593 0 1.3246v21.3508C0 23.4068.593 24 1.3245 24H12.819v-9.294H9.6913v-3.6221h3.1278V8.4128c0-3.1 1.8934-4.7879 4.6585-4.7879 1.3248 0 2.4631.0985 2.7949.1428v3.2395l-1.918.001c-1.504 0-1.795.7144-1.795 1.7631v2.3126h3.5866l-.4668 3.622h-3.1198V24h6.1158C23.4068 24 24 23.4068 24 22.6754V1.3246C24 .5929 23.4068 0 22.6753 0"
                  ></path>
                </svg>
              </a>

              <a
                href="https://www.linkedin.com/company/zirotohero"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  className="bui-Icon bui-Icon--large"
                >
                  <title>LinkedIn</title>
                  <path
                    fillRule="evenodd"
                    d="M22.2236 0c.9786 0 1.7777.7751 1.7777 1.7293v20.5391c0 .9556-.799 1.7316-1.7777 1.7316H1.7716C.7938 24 0 23.224 0 22.2684V1.7294C0 .775.7938 0 1.7716 0h20.452zm-1.773 20.4511V14.169c0-3.0849-.6653-5.4565-4.2675-5.4565-1.7315 0-2.8933.9498-3.3684 1.8503h-.0485v-1.565h-3.415v11.4534h3.5586v-5.6653c0-1.4947.2826-2.9414 2.135-2.9414 1.824 0 1.8503 1.7085 1.8503 3.037v5.5697h3.5556zM5.3383 7.432c1.1378 0 2.0627-.9249 2.0627-2.0644 0-1.1383-.9249-2.0636-2.0627-2.0636-1.1413 0-2.0635.9253-2.0635 2.0636 0 1.1395.9222 2.0644 2.0635 2.0644zM3.5573 20.4507h3.5614V8.9977H3.5573v11.453z"
                  ></path>
                </svg>
              </a>

              <a href="https://www.youtube.com/channel/UC86pJAgDxgPileTzgXz_Lxg">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 576 512"
                  className="bui-Icon bui-Icon--large"
                >
                  <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z" />
                </svg>
              </a>
            </dd>
          </dl>
        </div>
      </div>
    </StyledFooter>
  );
};

export default Footer;
